/* ===== Wagspan theme.js ===== */
(function () {
  'use strict';
  var W = window.Wagspan || {};

  function money(cents) {
    var fmt = (W.moneyFormat || '${{amount}}');
    var amt = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amt).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- Mobile nav ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nav-toggle]');
    if (t) { var nav = $('#SiteNav'); if (nav) nav.classList.toggle('is-open'); }
  });

  /* ---------- FAQ accordion ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.faq__q');
    if (q) { q.closest('.faq__item').classList.toggle('is-open'); }
  });

  /* ---------- Product buy box ---------- */
  function initBuyBox() {
    var box = $('[data-buybox]');
    if (!box) return;
    var form = $('[data-product-form]', box);
    var variantInput = $('[data-variant-id]', box);
    var sellingPlanInput = $('[data-selling-plan]', box);
    var addBtn = $('[data-add]', box);
    var weightInput = $('[data-dog-weight]', box);
    var planToggle = $('.plan-toggle', box);
    var bundleManuallySelected = false;
    var updateBar = function () {};

    function activeBundle() { return $('[data-bundle].is-active', box); }
    function setMode(mode) {
      $all('[data-plan]', box).forEach(function (x) {
        var isActive = x.getAttribute('data-plan') === mode;
        x.classList.toggle('is-active', isActive);
        x.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });
      box.setAttribute('data-mode', mode);
    }
    function doseForWeight(weight) {
      if (weight <= 25) return { chews: 1, days: 60 };
      return { chews: 2, days: 30 };
    }
    function recommendedBottleCount(weight) {
      return weight <= 25 ? 1 : 3;
    }
    function cadenceDaysFromName(name) {
      var match = String(name || '').toLowerCase().match(/every\s+(\d+)\s*(day|week|month)s?/);
      if (!match) return null;
      var count = parseInt(match[1], 10);
      if (match[2] === 'week') return count * 7;
      if (match[2] === 'month') return count * 30;
      return count;
    }
    function subscriptionState(bundle) {
      if (!bundle) return { id: '', name: '', cadence: '', days: null, compatible: false };
      var name = bundle.getAttribute('data-selling-plan-name') || '';
      var id = bundle.getAttribute('data-selling-plan-id') || '';
      return {
        id: id,
        name: name,
        cadence: bundle.getAttribute('data-selling-plan-cadence') || '',
        days: cadenceDaysFromName(name),
        compatible: !!id
      };
    }
    function supplyLabel(bottles, daysPerBottle) {
      var days = bottles * daysPerBottle;
      if (days > 120 && days % 30 === 0) return bottles + ' jars · approximately ' + (days / 30) + ' months';
      return bottles + ' jar' + (bottles === 1 ? '' : 's') + ' · ' + days + '-day supply';
    }
    function priceForBundle(bundle, mode) {
      return parseInt(bundle.getAttribute(mode === 'subscribe' ? 'data-sub-price' : 'data-price'), 10);
    }

    function updateWeightMath() {
      var hasWeight = !!weightInput;
      var weight = Math.max(1, parseFloat(weightInput ? weightInput.value : '48') || 48);
      var dose = doseForWeight(weight);
      var mode = box.getAttribute('data-mode');
      var selectedBundle = activeBundle();
      var subState = subscriptionState(selectedBundle);
      var selectedBottles = selectedBundle ? parseInt(selectedBundle.getAttribute('data-bottle-count'), 10) || 1 : 1;
      var recommendedBottles = hasWeight ? recommendedBottleCount(weight) : selectedBottles;
      var subPlan = $('[data-plan="subscribe"]', box);
      var cadenceNote = $('[data-subscription-cadence-note]', box);
      var selectedPlanName = $('[data-selected-plan-name]', box);
      if (selectedPlanName && subState.name) selectedPlanName.textContent = subState.name;
      if (planToggle && subState.name) planToggle.setAttribute('data-selling-plan-name', subState.name);
      if (subPlan) {
        subPlan.classList.toggle('is-disabled', !subState.compatible);
        subPlan.setAttribute('aria-disabled', subState.compatible ? 'false' : 'true');
      }
      if (cadenceNote) {
        cadenceNote.textContent = subState.compatible
          ? 'Renews every ' + subState.cadence + ' · free shipping · skip or cancel anytime.'
          : 'Choose a bundle with an available delivery schedule.';
      }
      if (mode === 'subscribe' && !subState.compatible) {
        setMode('onetime');
        syncSellingPlan();
        mode = 'onetime';
      } else if (mode === 'subscribe' && sellingPlanInput && subState.compatible) {
        sellingPlanInput.value = subState.id;
      }
      if (hasWeight && !bundleManuallySelected && mode !== 'subscribe') {
        var recommendedBundle = $('[data-bundle][data-bottle-count="' + recommendedBottles + '"]', box);
        if (recommendedBundle && !recommendedBundle.classList.contains('is-active')) {
          $all('[data-bundle]', box).forEach(function (bundle) {
            bundle.classList.remove('is-active');
            bundle.setAttribute('aria-checked', 'false');
          });
          recommendedBundle.classList.add('is-active');
          recommendedBundle.setAttribute('aria-checked', 'true');
          if (variantInput) variantInput.value = recommendedBundle.getAttribute('data-variant-id') || variantInput.value;
        }
      }
      var lowestPerDay = Infinity;
      $all('[data-bundle]', box).forEach(function (bundle) {
        var bottles = parseInt(bundle.getAttribute('data-bottle-count'), 10) || 1;
        var isRecommended = bottles === recommendedBottles;
        var fitBadge = $('[data-bundle-fit]', bundle);
        bundle.classList.toggle('bundle--recommended', isRecommended);
        if (fitBadge) fitBadge.hidden = !isRecommended;
        var duration = bottles * dose.days;
        var minimumDuration = bottles * 30;
        var maximumDuration = bottles * 60;
        var price = priceForBundle(bundle, mode);
        var durationEl = $('[data-bundle-duration]', bundle);
        if (durationEl) {
          var bundlePlan = subscriptionState(bundle);
          durationEl.textContent = mode === 'subscribe'
            ? bottles + ' jar' + (bottles === 1 ? '' : 's') + ' · delivered every ' + bundlePlan.cadence
            : (hasWeight ? supplyLabel(bottles, dose.days) : bottles + ' jar' + (bottles === 1 ? '' : 's') + ' · ' + minimumDuration + '–' + maximumDuration + ' days');
        }
        $all('[data-day-price]', bundle).forEach(function (el) {
          var rowMode = el.closest('[data-when]') ? el.closest('[data-when]').getAttribute('data-when') : mode;
          var rowPrice = priceForBundle(bundle, rowMode);
          if (!isNaN(rowPrice)) el.textContent = (hasWeight ? '' : 'from ') + money(Math.round(rowPrice / (hasWeight ? duration : maximumDuration)));
        });
        if (!isNaN(price)) lowestPerDay = Math.min(lowestPerDay, price / (hasWeight ? duration : maximumDuration));
      });
      var doseEl = $('[data-dose-result]', box);
      var daysEl = $('[data-bottle-days]', box);
      var fromEl = $('[data-from-day-price]', box);
      var fitEl = $('[data-routine-fit]', box);
      if (doseEl) doseEl.textContent = dose.chews + ' soft chew' + (dose.chews === 1 ? '' : 's');
      if (daysEl) daysEl.textContent = dose.days + ' days';
      if (fromEl && isFinite(lowestPerDay)) fromEl.textContent = money(Math.round(lowestPerDay));
      if (fitEl) fitEl.textContent = recommendedBottles + ' jar' + (recommendedBottles === 1 ? '' : 's');
      updateBuyBoxCta();
      updateBar();
    }

    function updateBuyBoxCta() {
      var active = activeBundle();
      var mode = box.getAttribute('data-mode');
      if (addBtn && active) {
        var bottles = parseInt(active.getAttribute('data-bottle-count'), 10) || 1;
        var price = priceForBundle(active, mode);
        if (mode === 'subscribe') addBtn.textContent = 'Subscribe & save 25% — ' + money(price);
        else if (bottles === 1) addBtn.textContent = 'Try Wagspan risk-free — ' + money(price);
        else if (bottles === 3) addBtn.textContent = 'Start the 90-day routine — ' + money(price);
        else addBtn.textContent = 'Get ' + bottles + ' jars — ' + money(price);
      }
      var offer = $('[data-offer-copy]', box);
      if (offer) {
        var offerText = offer.getAttribute(mode === 'subscribe' ? 'data-subscription-offer' : 'data-onetime-offer');
        var offerLabel = $('span', offer);
        if (offerText && offerLabel) offerLabel.textContent = offerText;
      }
    }

    // plan toggle (subscribe vs one-time)
    function choosePlan(p) {
        var nextMode = p.getAttribute('data-plan');
        if (nextMode === 'subscribe' && !subscriptionState(activeBundle()).compatible) {
          updateWeightMath();
          return;
        }
        setMode(nextMode);
        syncSellingPlan();
        updateWeightMath();
    }
    $all('[data-plan]', box).forEach(function (p) {
      p.addEventListener('click', function () { choosePlan(p); });
      p.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          choosePlan(p);
        }
      });
    });

    // bundle selection
    function chooseBundle(b) {
        bundleManuallySelected = true;
        $all('[data-bundle]', box).forEach(function (x) {
          x.classList.remove('is-active');
          x.setAttribute('aria-checked', 'false');
        });
        b.classList.add('is-active');
        b.setAttribute('aria-checked', 'true');
        if (variantInput) variantInput.value = b.getAttribute('data-variant-id') || variantInput.value;
        syncSellingPlan();
        updateWeightMath();
        var price = b.getAttribute('data-price');
        var pe = $('[data-current-price]', box);
        if (pe && price) pe.textContent = money(parseInt(price, 10));
    }
    $all('[data-bundle]', box).forEach(function (b) {
      b.addEventListener('click', function () { chooseBundle(b); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          chooseBundle(b);
        }
      });
    });

    function syncSellingPlan() {
      if (!sellingPlanInput) return;
      var mode = box.getAttribute('data-mode');
      if (mode === 'subscribe') {
        var plan = subscriptionState(activeBundle());
        sellingPlanInput.value = plan.compatible ? plan.id : '';
      } else {
        sellingPlanInput.value = '';
      }
    }

    // gallery thumbs
    $all('[data-thumb]', box.closest('.pdp') || document).forEach(function (th) {
      th.addEventListener('click', function () {
        $all('[data-gallery-main]').forEach(function (main) {
          main.src = th.getAttribute('data-full') || th.src;
          main.alt = th.alt || '';
        });
        $all('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        th.classList.add('is-active');
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var body = { items: [{ id: parseInt(variantInput.value, 10), quantity: 1 }] };
        if (box.getAttribute('data-mode') === 'subscribe') {
          if (!sellingPlanInput || !sellingPlanInput.value) {
            addBtn.textContent = 'Choose a delivery option';
            return;
          }
          body.items[0].selling_plan = parseInt(sellingPlanInput.value, 10);
        }
        addBtn.disabled = true; addBtn.dataset.label = addBtn.textContent; addBtn.textContent = 'Adding…';
        fetch(W.routes.cartAdd, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) {
          return r.json().then(function (payload) {
            if (!r.ok) throw new Error(payload.description || payload.message || 'Unable to add this offer');
            return payload;
          });
        }).then(function () {
          return refreshCart(true);
        }).catch(function (error) {
          addBtn.dataset.label = error.message || 'Please try again';
        }).finally(function () {
          addBtn.disabled = false; addBtn.textContent = addBtn.dataset.label || 'Add to cart';
        });
      });
    }
    syncSellingPlan();
    if (weightInput) weightInput.addEventListener('input', updateWeightMath);
    updateWeightMath();

    /* sticky buy bar */
    var bar = $('[data-stickybar]');
    if (bar && addBtn) {
      var barPrice = $('[data-stickybar-price]', bar);
      var barPlan = $('[data-stickybar-plan]', bar);
      var barAdd = $('[data-stickybar-add]', bar);
      var subPct = parseInt(bar.getAttribute('data-sub-pct') || '25', 10);

      updateBar = function () {
        var active = activeBundle();
        var mode = box.getAttribute('data-mode');
        var price = active ? priceForBundle(active, mode) : NaN;
        var bottles = active ? parseInt(active.getAttribute('data-bottle-count'), 10) || 1 : 1;
        var hasWeight = !!weightInput;
        var weight = Math.max(1, parseFloat(weightInput ? weightInput.value : '48') || 48);
        var duration = hasWeight
          ? supplyLabel(bottles, doseForWeight(weight).days)
          : bottles + ' jar' + (bottles === 1 ? '' : 's') + ' · ' + (bottles * 30) + '–' + (bottles * 60) + ' days';
        var cadence = subscriptionState(active).name;
        var barSupply = $('[data-stickybar-supply]', bar);
        if (!isNaN(price) && barPrice) barPrice.textContent = money(price);
        if (barPlan) barPlan.textContent = mode === 'subscribe' ? 'Subscribe & save · ' + subPct + '% off' : 'One-time purchase';
        if (barSupply) barSupply.textContent = duration + (mode === 'subscribe' && cadence ? ' · ' + cadence : '');
      };
      box.addEventListener('click', function () { setTimeout(updateBar, 0); });
      updateBar();

      if (barAdd && form) barAdd.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });

      var barTick = false;
      function syncBar() {
        barTick = false;
        var passed = addBtn.getBoundingClientRect().bottom < 0;
        bar.classList.toggle('is-visible', passed);
        bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
      }
      window.addEventListener('scroll', function () {
        if (!barTick) { barTick = true; requestAnimationFrame(syncBar); }
      }, { passive: true });
      syncBar();
    }
  }

  /* ---------- Cart drawer ---------- */
  function openCart() { var d = $('#CartDrawer'); if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); } }
  function closeCart() { var d = $('#CartDrawer'); if (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); } }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) closeCart();
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); refreshCart(false); }
  });

  function refreshCart(open) {
    return fetch(W.routes.cart).then(function (r) { return r.json(); }).then(function (cart) {
      renderDrawer(cart);
      $all('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
      if (open) openCart();
      return cart;
    });
  }

  function renderDrawer(cart) {
    var body = $('[data-cart-body]'), foot = $('[data-cart-foot]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var sub = it.selling_plan_allocation ? '<div class="tiny muted">' + it.selling_plan_allocation.selling_plan.name + '</div>' : '';
      var cartImage = it.handle === 'wagspan-longevity' && W.chewImage ? W.chewImage : it.image;
      return '<div class="mini-row">' +
        '<img src="' + (cartImage ? cartImage.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') : '') + '" alt="">' +
        '<div><div class="h5">' + it.product_title + '</div>' + sub +
        '<div class="tiny muted">Qty ' + it.quantity + '</div></div>' +
        '<strong>' + money(it.final_line_price) + '</strong></div>';
    }).join('');
    if (foot) {
      foot.hidden = false;
      var st = $('[data-cart-subtotal]'); if (st) st.textContent = money(cart.total_price);
      updateShipBar(cart.total_price);
    }
  }

  function updateShipBar(total) {
    var bar = $('[data-ship-bar]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
    if (!threshold) { bar.innerHTML = ''; return; }
    var pct = Math.min(100, Math.round((total / threshold) * 100));
    var remaining = threshold - total;
    var msg = remaining > 0 ? "You're " + money(remaining) + ' away from free shipping' : "You've unlocked free shipping!";
    bar.innerHTML = '<div class="ship-bar__msg">' + msg + '</div><div class="ship-bar__track"><div class="ship-bar__fill" style="width:' + pct + '%"></div></div>';
  }

  /* ---------- Cart page qty ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var row = btn.closest('[data-line]');
    var input = $('input', row.querySelector('.qty'));
    var val = parseInt(input.value, 10) || 1;
    val = btn.getAttribute('data-qty') === 'up' ? val + 1 : Math.max(0, val - 1);
    fetch(W.routes.cartChange, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(row.getAttribute('data-line'), 10), quantity: val })
    }).then(function () { location.reload(); });
  });

  document.addEventListener('DOMContentLoaded', function () {
    initBuyBox();
    refreshCart(false);
  });
})();
